import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, PreviousRouteService } from '../_helpers/index';
import { ICustomer, DebtorsPatchRequest } from '../_models/customer.interface';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { notificationStatus, notificationType } from '../_enums/index';
import { Notification } from '../_models';
import { BackFilterService } from '../_services';

@Component({
  selector: 'templates/list',
  templateUrl: './templatelist.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})
export class TemplateListComponent implements OnInit {

  public customer_public_id: string;
  excelExportData: any;
  ddlnotificationtype: any[];
  ddlnotificationStatus: any[];

  auth0Profile: any;

  searchFilterForm: FormGroup;
  displayedColumns: string[] = ['created', 'name', 'type', 'status'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  public iCustomer: ICustomer;
  debtorsPatchRequest: DebtorsPatchRequest[] = [];
  pageSize: number;
  PageSizeOptions: number[];
  isLoading = true;
  templateList = [];
  status: any = "All";
  type: any = "All";
  typeDropdownValue = 'TODOS';
  statusDropdownValue = 'TODOS';
  typeFormControl = new FormControl('TODOS');
  statusFormControl = new FormControl('TODOS');
  tempSearch: any;
  backToSearchSharedData: any;
  previousUrl: any;
  isBrowserBackButtonPressed: boolean = false;
  searchValue ='';
  pageIndex: number = 0;
  pageStart: number = 0;

  templateListLimit: number = 100;

  constructor
    (
      private customerService: CustomerService
      , private formBuilder: FormBuilder
      , private router: Router
      , private spinnerService: Ng4LoadingSpinnerService
      , private _notificationType: notificationType
      , private _notificationStatus: notificationStatus
      , private backFilterService:BackFilterService
      , private previousRouteService:PreviousRouteService
    ) {
    this.spinnerService.show();

    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;

    this.ddlnotificationtype = _notificationType.dbtType;
    this.ddlnotificationStatus = _notificationStatus.Status;
    this.backFilterService.getTemplateSearchSharedData().subscribe(data => this.backToSearchSharedData = data);
    this.backFilterService.getIsBrowserBackButtonPressedSharedData().subscribe(data => this.isBrowserBackButtonPressed = data);
  }//end cons

  applyFilter() {
    this.searchValue = this.searchFilterForm.controls.searchText.value.trim().toLowerCase();
    this.filter();
    this.paginator.firstPage();
    this.setBackToSearchFilter();
  }

  ngOnInit() {



    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
    }

    this.previousUrl = this.previousRouteService.getPreviousUrl();
    if ((this.isBrowserBackButtonPressed == true) &&
      (this.previousUrl.includes("/templates/")) &&
      (this.previousUrl.includes("/edit"))
    ) {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.setBackToSearchData();
    }else{
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.backFilterService.setTemplateSharedData(null);
    }

    this.searchFilterForm = this.formBuilder.group({
      searchText: [this.searchValue, Validators.required]
    });

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    this.GetCustomerNotificationDetails();
  }

  setBackToSearchData(){
    if (this.backToSearchSharedData != null) {
      this.searchValue = this.backToSearchSharedData.search;
      this.typeFormControl.setValue(this.backToSearchSharedData.typeDropdownValue);
      this.statusFormControl.setValue(this.backToSearchSharedData.statusDropdownValue);
      this.typeDropdownValue = this.backToSearchSharedData.typeDropdownValue;
      this.statusDropdownValue = this.backToSearchSharedData.statusDropdownValue;
      this.type = this.backToSearchSharedData.type;
      this.status = this.backToSearchSharedData.status;
      this.pageSize = this.backToSearchSharedData.pageSize;
      this.pageIndex = this.backToSearchSharedData.pageIndex;
      this.pageStart = this.backToSearchSharedData.pageStart;
      this.paginator.pageIndex = this.pageIndex;
      this.setBackToSearchFilter();
    }
  }

  GetCustomerNotificationDetails() {
    this.customerService.getCustomerNotificationTemplateList(this.customer_public_id, this.templateListLimit).subscribe(data => {
      this.isLoading = false;
      if (data && Array.isArray(data)) {
        let resources = data;
        this.dataSource.data = resources;
        this.excelExportData = resources;
        this.templateList = resources;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.filter();
      } else {
        this.dataSource.data = [];
        this.excelExportData = [];
        this.templateList = [];
      }
      this.spinnerService.hide();
    },
      error => {
        this.isLoading = false;
        console.log('Failed while trying to the Search All Result. ' + error);
        this.dataSource.data = [];
        this.excelExportData = [];
        this.templateList = [];
        this.spinnerService.hide();
      });
  }//end

  editNotificationDetails(element) {
    this.router.navigate([`/templates/${element.public_id}/edit`]);
  }

  filterTypeDetails(type) {
    this.typeDropdownValue = type;
    if(type == 'TODOS'){
      this.type = "All"
    }else  {
      this.type = type;
    }
    this.filter();
    this.paginator.firstPage();
    this.setBackToSearchFilter();
  }

  filterStatusDetails(status) {
    this.statusDropdownValue = status;
    if(status == 'TODOS'){
      this.status = "All"
    }else  {
      this.status = status;
    }
    this.filter();
    this.paginator.firstPage();
    this.setBackToSearchFilter();

  }//end

  filter() {
    var tempFilterData = this.templateList;
    if (this.status != "All") {
      tempFilterData = tempFilterData.filter(data => data.status == this.status)
    }

    if (this.type != "All") {
      tempFilterData = tempFilterData.filter(data => data.type == this.type)
    }
    if (this.searchFilterForm.controls.searchText.value.length > 0) {
      var serachValue = this.searchFilterForm.controls.searchText.value.trim();
      tempFilterData = tempFilterData.filter(data => data.name.toLowerCase().includes(serachValue.toLowerCase()))
    }

    this.dataSource.data = tempFilterData;
  }

  getDocumentType(idValue) {

    if (idValue == "1") {
      return "DNI";
    }
    if (idValue == "2") {
      return "RUC";
    }
    if (idValue == "3") {
      return "CE";
    }
    if (idValue == "4") {
      return "OTROS";
    }
  }//end

  pageEvent(event) {
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;
    this.setBackToSearchFilter();
  }

  setBackToSearchFilter(){
    this.tempSearch = {
      search: this.searchValue,
      typeDropdownValue: this.typeDropdownValue,
      statusDropdownValue: this.statusDropdownValue,
      type: this.type,
      status: this.status,
      pageSize: this.pageSize,
      pageIndex:this.pageIndex,
      pageStart: this.pageStart
    }
    this.backFilterService.setTemplateSharedData(this.tempSearch);
  }
}//end class


